// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","header1":"Header_header1__eNqTo","header2":"Header_header2__2ueqi","header3":"Header_header3__Skdw1"};